import { useDeviceType } from '@braskai/ui-kit';

import { ScopeSettings } from '@/shared/types/Settings';

import { useSettings } from './useSettings';

const defaultFeatureFlags = {
  enabled: false,
  metadata: {},
  visible: false,
};

export const useFeatureFlags = (featureFlag: keyof ScopeSettings['available_features']) => {
  const { isMobile, isTablet } = useDeviceType();

  const isMobileScreen = isMobile || isTablet;

  const {
    scope_settings: { available_features },
  } = useSettings();

  const {
    enabled,
    metadata: { desktop, download_disabled: downloadDisabled, mobile },
    visible,
  } = available_features[featureFlag] || defaultFeatureFlags;

  const featureAvailableForEveryone = enabled && !mobile && !desktop;
  const featureAvailableOnMobile = Boolean(enabled && mobile && isMobileScreen);
  const featureAvailableOnDesktop = Boolean(enabled && desktop);

  if (featureAvailableForEveryone) {
    return {
      featureDownloadDisabled: !!downloadDisabled,
      featureEnabled: featureAvailableForEveryone,
      featureVisible: visible,
    };
  }

  if (featureAvailableOnMobile) {
    return {
      featureDownloadDisabled: !!downloadDisabled,
      featureEnabled: featureAvailableOnMobile,
      featureVisible: visible,
    };
  }

  return {
    featureDownloadDisabled: !!downloadDisabled,
    featureEnabled: featureAvailableOnDesktop,
    featureVisible: visible,
  };
};
